import React, { Component } from 'react';
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip'
import 'react-table/react-table.css';

import { getNumberOfRows } from 'utils/paginator';
import { formatDate } from 'utils/date';

const DEFAULT_PAGE_SIZE = 10;

class Issued extends Component {
  constructor() {
    super();

    this.state = {
      page: 1
    };
  }

  render() {
    let { rewards, search, modalToggle } = this.props;
    const { page } = this.state;
    const rewardsLength = rewards.length;
    const numberOfRows = getNumberOfRows(page, rewardsLength, DEFAULT_PAGE_SIZE);

    const columns = [
      {
        id: 'surveyName',
        Header: 'Survey Name',
        style: { whiteSpace: 'unset' },
        accessor: d => d.location && d.location.name,
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { original }  = rowInfo;
            const { custom_survey_name: customSurveyName } = original;

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': customSurveyName,
              style: { cursor: customSurveyName ? 'pointer' : 'default' }
            };
          }

          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { custom_survey_name: customSurveyName } = original
          
          return (
            <span>
              <span>{customSurveyName}</span>
              <ReactTooltip place="top" type="dark" effect="solid" className="column-popover" globalEventOff="click" delayHide={50} />
            </span>
          );
        }
      },
      {
        Header: 'Reward',
        style: { whiteSpace: 'unset' },
        id: 'reward',
        accessor: d => d.title,
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { title } = rowInfo.original;

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': title,
              style: { cursor: title ? 'pointer' : 'default' }
            };
          }
          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { title } = original;

          return (
            <span>
              <span>{title}</span>
              <ReactTooltip place='top' type='dark' effect='solid' className='column-popover' globalEventOff='click' delayHide={50} />
            </span>
          );
        }
      },
      {
        id: 'locationName',
        Header: 'Location',
        style: { whiteSpace: 'unset' },
        accessor: (d) => {
          const { location } = d;
          const locationName = location ? `${location.state}, ${location.city}` : '';

          return locationName;
        },
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { location } = rowInfo.original;
            const locationName = location ?
              `${location.state}, ${location.city}` : '';

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': locationName,
              style: { cursor: locationName ? 'pointer' : 'default' }
            };
          }
          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { location } = original;
          const locationName = location ? `${location.state}, ${location.city}` : '';

          return (
            <span>
              <span>{locationName}</span>
              <ReactTooltip place='top' type='dark' effect='solid' className='column-popover' globalEventOff='click' delayHide={50} />
            </span>
          )
        }
      },
      {
        id: 'friendName',
        Header: 'Full Name',
        style: { whiteSpace: 'unset' },
        accessor: (d) => {
          const firstName = d.survey_user.first_name ? d.survey_user.first_name : '';
          const lastName = d.survey_user.last_name ? d.survey_user.last_name : '';

          return `${firstName} ${lastName}`;
        },
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { survey_user } = rowInfo.original;
            const firstName = survey_user.first_name ? survey_user.first_name : '';
            const lastName = survey_user.last_name ? survey_user.last_name : '';

            const fullName = `${firstName} ${lastName}`;

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': fullName.trim(),
              style: { cursor: fullName.trim() ? 'pointer' : 'default' }
            };
          }
          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { survey_user } = original;

          const firstName = survey_user.first_name ? survey_user.first_name : '';
          const lastName = survey_user.last_name ? survey_user.last_name : '';

          const fullName = `${firstName} ${lastName}`;

          return (
            <span>
              <span>{fullName.trim()}</span>
              <ReactTooltip place="top" type="dark" effect="solid" className="column-popover" globalEventOff="click" delayHide={50} />
            </span>
          );
        }
      },
      {
        id: 'userEmail',
        Header: 'Email',
        style: { whiteSpace: 'unset' },
        accessor: d => d.survey_user.email,
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { survey_user } = rowInfo.original;

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': survey_user.email,
              style: { cursor: survey_user.email ? 'pointer' : 'default' }
            };
          }
          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { survey_user } = original;

          return (
            <span>
              <span>{survey_user.email}</span>
              <ReactTooltip place='top' type='dark' effect='solid' className='column-popover' globalEventOff='click' delayHide={50} />
            </span>
          )
        }
      },
      {
        Header: 'Coupon Code',
        sortable: false,
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            const { token } = rowInfo.original;

            return {
              'data-offset': '{"top": -5}',
              'data-event': 'click focus',
              'data-tip': token,
              style: { cursor: token ? 'pointer' : 'default' }
            };
          }
          return {
            style: { className: '-striped -highlight' }
          };
        },
        Cell: ({ original }) => {
          const { token } = original;

          return (
            <span>
              <span>{token}</span>
              <ReactTooltip place='top' type='dark' effect='solid' className='column-popover' globalEventOff='click' delayHide={50} />
            </span>
          );
        }
      },
      {
        id: 'issuedDate',
        Header: 'Issued On',
        accessor: d => new Date(d.created_at),
        Cell: ({ original }) => {
          const { created_at } = original;
          const issuedDate = new Date(created_at);
          const formattedIssuedDate = formatDate(issuedDate);

          return (
            <span>
              {formattedIssuedDate}
            </span>
          );
        }
      },
      {
        id: 'userAction',
        Header: 'Redeemed On',
        Cell: ({ original }) => {
          const { redeemed_date } = original;

          if (!redeemed_date) {
            return (
              <button
                className='btn-add-new float-none cursor-pointer'
                onClick={modalToggle.bind(this, original)}
              >
                Redeem
              </button>
            );
          }

          const redeemDate = new Date(redeemed_date);
          const formattedRedeemDate = formatDate(redeemDate);

          return (
            <span>
              {formattedRedeemDate}
            </span>
          );
        }
      }
    ];

    if (search) {
      const searchToLocaleLowerCase = search.toLocaleLowerCase();

      rewards = rewards.filter(row => {
        return (
          row.token.toLowerCase().includes(searchToLocaleLowerCase) ||
          row.title.toLowerCase().includes(searchToLocaleLowerCase) ||
          (row.survey_user.email && row.survey_user.email.toLowerCase().includes(searchToLocaleLowerCase)) ||
          row.location && (row.location.city
            .toLowerCase()
            .includes(searchToLocaleLowerCase) ||
            row.location.state.toLowerCase().includes(searchToLocaleLowerCase) ||
            row.location.name.toLowerCase().includes(searchToLocaleLowerCase))
        );
      });
    }

    const pageSize = (rewards.length === 0 || rewards.length > DEFAULT_PAGE_SIZE) ? DEFAULT_PAGE_SIZE : rewards.length;
    const minRows = rewards.length ? 0 : 2;

    return (
      <div>
        <div>
          <ReactTable
            className='styled-box-shadow bg-white'
            data={rewards}
            columns={columns}
            showPagination={true}
            showPageSizeOptions={false}
            defaultPageSize={pageSize}
            minRows={minRows}
            resizable={false}
            hasColumnFooter={true}
            showPaginationBottom={true}
            onPageChange={(page) => {
              this.setState({ page: page + 1 });
              ReactTooltip.rebuild();
            }}
          />
        </div>

        {rewards && rewards.length ?
          <div className='page-size-detail'>
            <b>{numberOfRows}</b> of <b>{rewardsLength}</b> issued voucher{rewardsLength > 1 ? 's' : ''}
          </div>
          : null
        }
      </div>
    );
  }
}

export default Issued;



// WEBPACK FOOTER //
// ./src/components/redemption/Issued.js